import React from "react";
import { novaContentURL } from "utilFunctions/Constants/urlConstants";

const NovaContent = () => {
  return (
    <div
      className={
        !["xs", "sm", "md"].includes(screen)
          ? "w-100 batchTableContainer pt-0 pb-1 mt-2"
          : "w-100 ml-0 mr-0"
      }
      style={{
        height: "calc(100vh - 62px)",
        overflow: "auto",
      }}
    >
      <iframe
        src={novaContentURL}
        height={"100%"}
        width={"100%"}
        style={{ border: "none" }}
        title="Concept Kundli"
      ></iframe>
    </div>
  );
};
export default NovaContent;
